import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const StatCard = ({
    title,
    value,
    subtitle,
    icon: Icon,
    trend,
    trendLabel,
    color = 'primary',
    onClick,
    className = ''
}) => {
    const colorClasses = {
        primary: 'bg-primary/10 text-primary',
        green: 'bg-green-100 text-green-600',
        red: 'bg-red-100 text-red-600',
        amber: 'bg-amber-100 text-amber-600',
        blue: 'bg-blue-100 text-blue-600',
        purple: 'bg-purple-100 text-purple-600',
        gray: 'bg-gray-100 text-gray-600'
    };

    const getTrendIcon = () => {
        if (trend > 0) return <TrendingUp className="w-4 h-4 text-green-500" />;
        if (trend < 0) return <TrendingDown className="w-4 h-4 text-red-500" />;
        return <Minus className="w-4 h-4 text-gray-400" />;
    };

    const getTrendColor = () => {
        if (trend > 0) return 'text-green-600';
        if (trend < 0) return 'text-red-600';
        return 'text-gray-500';
    };

    return (
        <div
            className={`bg-white rounded-xl border border-gray-200 p-5 ${onClick ? 'cursor-pointer hover:shadow-md hover:border-gray-300 transition-all' : ''} ${className}`}
            onClick={onClick}
        >
            <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-500 mb-1 truncate" title={title}>{title}</p>
                    <p className="text-2xl font-bold text-gray-900 truncate" title={value}>{value}</p>
                    {subtitle && (
                        <p className="text-sm text-gray-500 mt-1 truncate" title={subtitle}>{subtitle}</p>
                    )}
                    {trend !== undefined && (
                        <div className="flex items-center gap-1 mt-2 flex-wrap">
                            {getTrendIcon()}
                            <span className={`text-sm font-medium ${getTrendColor()} whitespace-nowrap`}>
                                {trend > 0 ? '+' : ''}{trend}%
                            </span>
                            {trendLabel && (
                                <span className="text-xs text-gray-400 ml-1 truncate" title={trendLabel}>{trendLabel}</span>
                            )}
                        </div>
                    )}
                </div>
                {Icon && (
                    <div className={`p-3 rounded-lg ${colorClasses[color]}`}>
                        <Icon className="w-5 h-5" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default StatCard;
